export class ControlViolationsPerSeverity {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "allAffectedResources",
            "baseName": "allAffectedResources",
            "type": "number",
            "format": ""
        },
        {
            "name": "violatedControls",
            "baseName": "violatedControls",
            "type": "Array<ControlViolationsPerSeverityViolatedControlsInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ControlViolationsPerSeverity.attributeTypeMap;
    }
    constructor() {
    }
}
